import styled from "styled-components";

export const PostHeaderContaniner = styled.article`
  display: flex;
  margin: 0 0 12px 16px;
`;
